export { default } from "./src/tabs-8-col";
// @ts-ignore
export type { UniformTabs8ColProps } from "./src/tabs-8-col";
